// invest_FE/src/components/MaintenanceOverlay.js
import React from 'react';
import './MaintenanceOverlay.css';

const MaintenanceOverlay = ({ message }) => {
  return (
    <div className="maintenance-overlay">
      <div className="maintenance-content">
        <h2>System Maintenance</h2>
        <p>{message}</p>
      </div>
    </div>
  );
};

export default MaintenanceOverlay;
